import css from '@utils/css'
import React from 'react'

export const Bg = ({ className }) => {
    return (
        <svg className={css(className)} viewBox="0 0 905 798" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.1115 669.236C-2.57487 643.104 -9.33246 597.224 13.4738 563.064L365.635 35.5935C386.599 4.19358 426.656 -8.27947 461.738 5.66895L854.53 161.842C911.804 184.614 922.91 260.875 874.51 299.039L263.52 780.817C233.951 804.134 192.126 803.675 163.075 779.716L29.1115 669.236Z" fill="#F95842"/>
        </svg>
    )
}
